import type { UseMutationResult } from "@tanstack/react-query"
import { useMutation } from "@tanstack/react-query"

import type { ImageryResponseDto } from "../dto/imagery.dto"
import { imageryService } from "../services/imagery.service"

interface FetchImageryOnDemandParams {
  siteId: string
  provider: `nearmap`
}

export default function useFetchImageryOnDemand(): UseMutationResult<
  ImageryResponseDto[],
  Error,
  FetchImageryOnDemandParams
> {
  return useMutation({
    mutationFn: ({ siteId, provider }: FetchImageryOnDemandParams) =>
      imageryService.fetchImageryForProvider(siteId, provider),
  })
}
